<template>
  <div id="app">
    <el-container style="border: 1px solid #eee; min-width: 1640px; min-height: calc(100vh - 16px);">
	    <nav-bar></nav-bar> 
      <el-container>
    		<el-main>
          <el-breadcrumb separator="/" v-if="!($route.name=='home')">
            <el-breadcrumb-item><router-link to="home">Главная</router-link></el-breadcrumb-item>
            <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
          </el-breadcrumb>
          <h1>{{$route.meta.title}}</h1>
        	 <router-view></router-view>
    		</el-main>
      </el-container>
	  </el-container>
    <el-backtop></el-backtop>
  </div>
</template>

<style>
  .el-header {
    background-color: #B3C0D1;
  }
  img { 
    image-rendering: optimizeSpeed;
    image-rendering: -moz-crisp-edges;
    image-rendering: -o-crisp-edges;
    image-rendering: -webkit-optimize-contrast;
    image-rendering: pixelated;
    image-rendering: optimize-contrast;
    -ms-interpolation-mode: nearest-neighbor;
  }
  body .el-notification__content{
    text-align: left;
    max-height: 50vh;
    overflow: auto;
  }
  body .el-tooltip__popper{
    max-width: 300px;
  }
</style>

<script>
import NavBar from "./components/NavBar";
export default {
  components: {
    NavBar,
  },
  data(){
    return {
    }
  },
};
</script>

